import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductDistributorForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'distributoerrer', dataApiName: 'ProductDistributor', text: 'Distributører', textSingular: "Distributør",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, 
      fieldMetadata: [
        { name: 'onix', text: 'ONIX' }
      ]
    });
  }
}
